import React, { useRef, useLayoutEffect, useEffect, useState } from 'react'
import WaveSurfer from 'wavesurfer.js';


const defaultProps = {
  playing: false,
  stop: false,
  volume: 0,
  background: '#FFF',
  ready: () => {}
}

let idx = 0

const Waveform = (props) => {
  const waveProps = {...defaultProps, ...props}
  const dom = useRef()
  const [wave, setWave] = useState(null)
  // const fetchData = useCallback(() => fetch(waveProps.json), [waveProps.json])
  // const { value: jsonValue, execute } = useAsync(fetchData, false)

  useLayoutEffect(() => {
    // console.log('effect', dom.current)
    if (wave && wave.mediaContainer === dom.current) {
      return
    }
    if (wave) {
      // console.log('destroy old')
      wave.destroy()
    }
    // create
    // TODO 修改为参数
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent || '') || /iPad|iPhone|iPod/i.test(navigator.userAgent || '');
    const wavesurfer = WaveSurfer.create({
      container: dom.current,
      backend: isSafari ? 'MediaElement' : 'WebAudio',
      waveColor: 'rgba(136, 136, 136, 0.4)',
      backgroundColor: waveProps.background || '#FFF',
      progressColor: '#FF6500',
      height: props.height || 120,
      barWidth: 2,
      barGap: 1,
      barMinHeight: 1,
      cursorWidth: 0,
      normalize: true,
      hideScrollbar: true
    })
    
    // wavesurfer.backend.setPeaks(waveProps.data);
    // wavesurfer.drawBuffer();
    // bind
    // wavesurfer.on('ready', function () {
    //   // if (waveProps.playing) {
    //   //   wavesurfer.play();
    //   // }
    //   console.log('======ready=======', props, wavesurfer)
    // })
    // wavesurfer.on('waveform-ready', function () {
    //   setTimeout(() => {
    //     console.log('======waveform-ready=======', props, wavesurfer.handlers)
    //   }, 1)
    // })
    if (waveProps.url && waveProps.data) {
      // console.log(waveProps.url, waveProps.data)
      wavesurfer.load(waveProps.url, waveProps.data, false);
    }
    else if (waveProps.url) {
      //wavesurfer.load(waveProps.url);
    }
    wavesurfer.setVolume(waveProps.volume / 100)
    setWave(wavesurfer)

    ///window.wavesurfer1 = wavesurfer
    return () => {
      // console.log('wavesurfer destroy')
      wavesurfer.destroy()
    }
  }, [])

  // useEffect(() => {
  //   if (!wave) {
  //     return
  //   }
  //   if (waveProps.url) {
  //     wave.load(waveProps.url)
  //   }
  //   else {
  //     wave.empty()
  //   }
  // }, [waveProps.url, wave])

  // useEffect(() => {
  //   if (jsonValue) {
  //     // TODO 问题
  //     wave.load(waveProps.url, jsonValue)
  //   }
  // }, [jsonValue, wave])

  // useEffect(() => {
  //   if (!wave) {
  //     return
  //   }
  //   if (waveProps.playing) {
  //     wave.playPause()
  //   }
  //   else if (waveProps.stop) {
  //     wave.stop()
  //   }
  //   else {
  //     wave.pause()
  //   }
  // }, [waveProps.playing, waveProps.stop, wave])

  useEffect(() => {
    if (!wave) {
      return
    }
    // console.log('waveProps.volume', waveProps.volume)
    wave.setVolume(waveProps.volume / 100)
  }, [waveProps.volume, wave])

  useEffect(() => {
    if (wave && waveProps.ready) {
      waveProps.ready(wave)
    }
  }, [wave, waveProps.ready])

  return <div id={`Waveform-${idx ++}`} ref={dom}></div>
}

export default Waveform